import { useCallback } from 'react'
import { useNavigate, NavigateOptions, To, useLocation } from 'react-router-dom'

export default function useNavigateMergingState<State>() {
  const navigate = useNavigate()
  const locationState: State | undefined = useLocation().state

  const navigateMergingState = useCallback(
    (
      to: To,
      options: Omit<NavigateOptions, 'state'> & { state?: Partial<State> }
    ) => {
      const { state } = options

      navigate(to, {
        ...options,
        state: {
          ...locationState,
          ...state
        }
      })
    },
    [locationState, navigate]
  )

  return navigateMergingState
}
